var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_8521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1336,
    height: 6492,
    transform: "translate(-1092 -10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5903_8521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1142,
    y: -10,
    width: 1467,
    height: 78,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5773,
    cy: 21.5773,
    r: 20.9608,
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 1.23299
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8212 33.152C26.8271 33.152 26.848 33.152 26.8539 33.152C27.4694 33.152 28.0511 32.9095 28.4918 32.4688L31.6535 29.3072C32.1093 28.8513 32.1093 28.1145 31.6535 27.6587L26.9903 22.9955C26.5344 22.5397 25.7976 22.5397 25.3418 22.9955L23.4835 24.8538C22.622 24.5973 21.0143 24.0144 19.9954 22.9955C18.9765 21.9766 18.3936 20.3689 18.1371 19.5074L19.9954 17.6491C20.4513 17.1933 20.4513 16.4565 19.9954 16.0007L15.3322 11.3374C14.895 10.9003 14.1209 10.9003 13.6838 11.3374L10.5233 14.4991C10.0803 14.9421 9.83077 15.5506 9.8401 16.172C9.86691 17.8321 10.3064 23.5982 14.8507 28.1425C19.395 32.6868 25.1611 33.1252 26.8212 33.152ZM14.5091 13.8101L17.5239 16.8249L16.0165 18.3323C15.7379 18.6097 15.619 19.0108 15.7006 19.3955C15.7286 19.5295 16.4129 22.7087 18.3481 24.6439C20.2834 26.5792 23.4625 27.2635 23.5966 27.2915C23.9848 27.3731 24.3824 27.2542 24.6598 26.9755L26.1672 25.4682L29.182 28.4829L26.8434 30.8204C25.3884 30.7959 20.4105 30.4053 16.4992 26.4929C12.5751 22.5688 12.195 17.5733 12.1717 16.1475L14.5091 13.8101ZM30.8234 20.3281H33.155C33.155 14.3475 28.6399 9.83704 22.6511 9.83704V12.1686C27.3866 12.1686 30.8234 15.5996 30.8234 20.3281Z",
    fill: "#A33635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6621 16.8315C25.1138 16.8315 26.1595 17.8772 26.1595 20.3289H28.4911C28.4911 16.5692 26.4218 14.4999 22.6621 14.4999V16.8315Z",
    fill: "#A33635"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5903_8521",
    x: -1154,
    y: -18,
    width: 1491,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5903_8521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5903_8521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_8521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1336,
    height: 6492,
    fill: "white",
    transform: "translate(-1092 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertPc);
export default __webpack_public_path__ + "static/media/ExpertPC.14acc07a63ab130df134fd9c44e14733.svg";
export { ForwardRef as ReactComponent };